import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Crown, CheckCircle2, Loader2, AlertTriangle } from "lucide-react";
import { api } from "../api";
import { useAuth } from "../contexts";

export default function CulturePassSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { setUser } = useAuth();
  const [state, setState] = useState({ status: "loading", txn: null });
  const refreshed = useRef(false);

  useEffect(() => {
    if (!sessionId) return setState({ status: "missing" });
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      attempts += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          if (!refreshed.current) {
            refreshed.current = true;
            try {
              const me = await api.get("/auth/me");
              setUser(me.data);
            } catch (e) { console.warn("Failed to refresh user after culture-pass purchase:", e); }
          }
          setState({ status: "paid", txn: r.data });
        } else if (attempts >= 8) {
          setState({ status: "timeout", txn: r.data });
        } else {
          setTimeout(poll, 2000);
        }
      } catch { setState({ status: "error" }); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]); // eslint-disable-line

  return (
    <div className="max-w-[700px] mx-auto px-4 sm:px-6 py-20 text-center pb-32" data-testid="pass-success-page">
      {state.status === "loading" ? (
        <><Loader2 className="mx-auto animate-spin text-[var(--accent)]" size={42} /><h1 className="font-display text-4xl uppercase mt-6">Activating your pass…</h1></>
      ) : state.status === "paid" ? (
        <>
          <Crown className="mx-auto text-[var(--acid)]" size={56} />
          <h1 className="font-display text-5xl uppercase mt-6">Culture Pass Active</h1>
          <p className="text-neutral-300 mt-4">You&apos;re in. 30 days of ad-free streaming, early drops, 10% off merch, and supporter badges unlocked.</p>
          <div className="flex gap-3 justify-center mt-8">
            <Link to="/mixtapes" className="btn-primary">Stream Mixtapes</Link>
            <Link to="/merch" className="btn-ghost">Shop with 10% off</Link>
          </div>
        </>
      ) : (
        <><AlertTriangle className="mx-auto text-[var(--accent)]" size={42} /><h1 className="font-display text-4xl uppercase mt-6">Could not confirm pass</h1><Link to="/culture-pass" className="btn-ghost mt-6">Try Again</Link></>
      )}
    </div>
  );
}
